import React, { useImperativeHandle, useState, useRef } from 'react';
import { ClubDialog, EnsureAccountsDialog } from '@Local/ClubCompany/Dialog/';
import useForkRef from '@Util/hook/useForkRef';

const ClubDialogBox = React.forwardRef((props, ref) => {
    const dialogRef = useRef(null);
    const combinedRef = useForkRef(ref, dialogRef);
    const [openDialog, setOpenDialog] = useState('');
    const [sourceData, setSourceData] = useState({});
    const refreshRef = useRef(null);

    const doRefresh = () => {
        if (refreshRef.current && typeof refreshRef.current === 'function') {
            const fn = refreshRef.current;
            setTimeout(fn, 300);
        }
    };

    useImperativeHandle(
        combinedRef,
        () => {
            return {
                openClubDialog: (targetData, _refreshFn = () => {}) => {
                    setSourceData(targetData || {});
                    setOpenDialog('club');
                    refreshRef.current = _refreshFn;
                },
                openEnsureAccountsDialog: (targetData, _refreshFn = () => {}) => {
                    setSourceData(targetData || {});
                    setOpenDialog('ensure-accounts');
                    refreshRef.current = _refreshFn;
                },
                closeDialog: () => handleCloseDialog(),
            };
        },
        // eslint-disable-next-line
        []
    );

    const handleCloseDialog = () => {
        setOpenDialog(null);
        setSourceData(null);
        refreshRef.current = null;
    };

    return (
        <React.Fragment>
            <ClubDialog open={openDialog === 'club'} onClose={handleCloseDialog} sourceData={sourceData} refresh={doRefresh} />
            <EnsureAccountsDialog
                open={openDialog === 'ensure-accounts'}
                onClose={handleCloseDialog}
                sourceData={sourceData}
                refresh={doRefresh}
            />
        </React.Fragment>
    );
});

export default ClubDialogBox;
